import axios from "axios"
import { useFormik } from "formik"
import React, { useEffect, useState } from "react"
import * as Yup from "yup"
import { ToastContainer, toast } from "react-toastify"
import { Link, useNavigate, useParams } from "react-router-dom"
import { Form } from "react-bootstrap"
import { request } from "../services/request"
import { FPinterface } from "../services/authinterface"
import GradientBackground from "../components/common/GradientBackground"
const Resetpassword: React.FC = () => {
  const navigate = useNavigate()
  const param = useParams()
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setConfirmShowPassword] = useState(false)

  useEffect(() => {
    if (!param.token) {
      toast.error("Token is missing in the URL")
      navigate("/login")
      return
    }
    const apiCall = async () => {
      try {
        const response = await request<FPinterface>({
          url: `/admin/checkToken/${param.token}`,
          method: "GET",
        })
        if (!response.data) {
          toast.error("Token is Invalid")
          navigate("/login")
          return
        }
      } catch (error: any) {
        toast.error(error.message || "An error occurred")
      }
    }
    apiCall()
  }, [param.token, navigate])

  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .required("Please enter Password")
      .min(6, "Password must be at least 6 characters"),

    c_password: Yup.string()
      .required("Please confirm your password")
      .oneOf([Yup.ref("password")], "Passwords must match"),
  })
  const formik = useFormik({
    initialValues: {
      password: "",
      c_password: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {

        const params = {
          password: values.password,
        }

        const response = await request<FPinterface>({
          url: `/admin/resetPassword/${param.token}`,
          method: "POST",
          data: params,
        })
        if (response.data) {
          toast.success(response.message || "Password reset successful")
          setTimeout(() => {
            navigate("/login")
          }, 500)
          return
        } else {
          console.error("Login failed:", response)
          toast.error("failed: " + response.message)
        }
      } catch (error) {
        if (axios.isAxiosError(error)) {
          // Handle Axios error
          if (error?.response) {
            // Server responded with a status other than 2xx
            toast.error(`Error: ${error.response.data.message}`)
          } else if (error?.request) {
            // Request was made but no response received
            toast.error("failed: No response from server")
          } else {
            // Something else happened while setting up the request
            toast.error(`failed: Something went wrong`)
          }
        } else {
          // Handle non-Axios error
          toast.error("An unexpected error occurred")
        }
        console.error("failed:", error)
      }
    },
  })
  return (
    <section className='login-section'>
      <ToastContainer position='top-right' autoClose={2000} theme='light' />
      <div className='gradint-main-section'>
        <GradientBackground />
      </div>
      <div className='container'>
        <div className='mian-login-section'>
          <div className='login-container'>
            <div className='login-filed-container'>
              <div className='py-3.5 px-4  md:p-12  w-full login-title-section'>
                <h2 className='login-title font-Poppins-Medium text-xl  md:text-[26px] leading-[36px] tracking-[-0.2px] text-gray-700 mb-2 md:mb-4'>
                  Reset password
                </h2>
                <form onSubmit={formik.handleSubmit} className='login-form'>
                  <div className='login-input-section input-section'>
                    <div className='flex items-center justify-between'>
                      <label htmlFor='' className='font-Poppins-Medium text-sm  text-[#414552]'>
                        Password
                      </label>
                    </div>
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      name='password'
                      placeholder='Enter password'
                      value={formik.values.password}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={!!formik.errors.password && formik.touched.password}
                    />
                    <span className='text-red-500 text-xs'>
                      {formik.touched.password && formik.errors.password}
                    </span>
                    {formik.values.password.length > 0 && (
                      <button
                        type='button'
                        onClick={() => setShowPassword((prev) => !prev)}
                        // className='absolute right-2.5 top-11 cursor-pointer showPassIcon'
                        className={`absolute top-11 cursor-pointer showResetPassIcon ${!!formik.errors.password && formik.touched.password && "right-22"}`}
                      >
                        {showPassword ? (
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            fill='none'
                            viewBox='0 0 24 24'
                            strokeWidth={1.5}
                            stroke='currentColor'
                            className='passIcon'
                          >
                            <path
                              strokeLinecap='round'
                              strokeLinejoin='round'
                              d='M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z'
                            />
                            <path
                              strokeLinecap='round'
                              strokeLinejoin='round'
                              d='M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z'
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            fill='none'
                            viewBox='0 0 24 24'
                            strokeWidth={1.5}
                            stroke='currentColor'
                            className='passIcon'
                          >
                            <path
                              strokeLinecap='round'
                              strokeLinejoin='round'
                              d='M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88'
                            />
                          </svg>
                        )}
                      </button>
                    )}
                  </div>

                  <div className='login-input-section'>
                    <div className='flex items-center justify-between'>
                      <label htmlFor='' className='font-Poppins-Medium text-sm  text-[#414552]'>
                        Confirm Password
                      </label>
                    </div>
                    <Form.Control
                      type={showConfirmPassword ? "text" : "password"}
                      name='c_password'
                      placeholder='Enter confirm password'
                      value={formik.values.c_password}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      isInvalid={!!formik.errors.c_password && formik.touched.c_password}
                    />
                    <span className='text-red-500 text-xs'>
                      {formik.touched.c_password && formik.errors.c_password}
                    </span>
                    {formik.values.c_password.length > 0 && (
                      <button
                        type='button'
                        onClick={() => setConfirmShowPassword((prev) => !prev)}
                        // className='absolute right-2.5 top-11 cursor-pointer showPassIcon'
                        className={`absolute top-11 cursor-pointer showResetPassIcon ${!!formik.errors.c_password && formik.touched.c_password && "right-22"}`}
                      >
                        {showConfirmPassword ? (
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            fill='none'
                            viewBox='0 0 24 24'
                            strokeWidth={1.5}
                            stroke='currentColor'
                            className='passIcon'
                          >
                            <path
                              strokeLinecap='round'
                              strokeLinejoin='round'
                              d='M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z'
                            />
                            <path
                              strokeLinecap='round'
                              strokeLinejoin='round'
                              d='M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z'
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            fill='none'
                            viewBox='0 0 24 24'
                            strokeWidth={1.5}
                            stroke='currentColor'
                            className='passIcon'
                          >
                            <path
                              strokeLinecap='round'
                              strokeLinejoin='round'
                              d='M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88'
                            />
                          </svg>
                        )}
                      </button>
                    )}
                  </div>

                  <Link
                    to='/login'
                    className='font-Poppins-SemiBold text-[12px]  text-[#635bff] transition-all duration-300 ease-in-out hover:text-[rgb(26,31,54)]'
                  >
                    Back to Login
                  </Link>

                  <button
                    type='submit'
                    className='submit-button w-full block mt-4 text-base text-white leading-[28px] px-4 py-2 bg-[rgb(99,91,255)] rounded-sm'
                  >
                    Create Password
                  </button>
                </form>
              </div>
            </div>
            <div className='login-info-section '>
              <div className=''>
                <svg
                  aria-hidden='true'
                  width='16'
                  height='16'
                  viewBox='0 0 16 16'
                  xmlns='http://www.w3.org/2000/svg'
                  className='w-full max-w-[12px] min-w-[12px] h-[12px] mt-1'
                >
                  <path d='M8.75 11.25a1.25 1.25 0 1 0-1.5 0v1a.75.75 0 0 0 1.5 0v-1Z'></path>
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M3.5 4v2h-1a1 1 0 0 0-1 1v6a3 3 0 0 0 3 3h7a3 3 0 0 0 3-3V7a1 1 0 0 0-1-1h-1V4a4 4 0 0 0-4-4h-1a4 4 0 0 0-4 4ZM11 6V4a2.5 2.5 0 0 0-2.5-2.5h-1A2.5 2.5 0 0 0 5 4v2h6Zm-8 7V7.5h10V13a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 3 13Z'
                  ></path>
                </svg>
                <p className='text-[13px] font-Poppins-Regular'>
                  Never share your Gunsens credentials.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Resetpassword
